import { IconButton, IconButtonProps } from "@chakra-ui/react";
import { FiEdit2 } from "react-icons/fi";

export default function InputEditButton({ ...rest }: IconButtonProps) {
  return <IconButton icon={<FiEdit2 />} size="2xs" variant="tertiary" {...rest} />;
}
